import { detect } from 'detect-browser';

const browser = detect();
const safariMinVersion = '11';
const safariMaxVersion = '17';
const camera = 'camera';
const microphone = 'microphone';

class CheckMediaAccess {
    constructor() {
        this.state = {
            cameraGranted: false,
            microphoneGranted: false,
            browserCameraBlocked: false,
            browserMicrophoneBlocked: false,
            systemCameraBlocked: false,
            systemMicrophoneBlocked: false,
        };
        this.isStudent = false;
    }

    //checkCameraAccess
    async checkCameraAccess() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            if (stream.getVideoTracks().length > 0) {
                console.log('Camera is accessible at the system level.');
                this.state.cameraGranted = true;
            } else {
                console.log('Camera is not accessible at the system level.');
            }
            stream.getTracks().forEach((track) => track.stop()); // Stop the stream after checking
        } catch (error) {
            if (
                error instanceof DOMException &&
                error.message.includes('Permission denied by system')
            ) {
                console.log('Permission denied by system');
                this.state.systemCameraBlocked = true;
                this.state.browserCameraBlocked = false;
            } else {
                console.error('An error occurred: ', error.message);
                this.state.browserCameraBlocked = true;
                this.state.systemCameraBlocked = false;
            }
        }
    }

    //checkMicrophoneAccess
    async checkMicrophoneAccess() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            if (stream.getAudioTracks().length > 0) {
                console.log('Microphone is accessible at the system level.');
                this.state.microphoneGranted = true;
            } else {
                console.log('Microphone is not accessible at the system level.');
            }
            stream.getTracks().forEach((track) => track.stop()); // Stop the stream after checking
        } catch (error) {
            if (
                error instanceof DOMException &&
                error.message.includes('Permission denied by system')
            ) {
                console.log('Permission denied by system');
                this.state.systemMicrophoneBlocked = true;
                this.state.browserMicrophoneBlocked = false;
            } else {
                console.error('An error occurred: ', error.message);
                this.state.browserMicrophoneBlocked = true;
                this.state.systemMicrophoneBlocked = false;
            }
        }
    }

    //checkPermission
    async checkPermission() {
        if (
            browser.name === 'safari' &&
            browser.version > safariMinVersion &&
            browser.version < safariMaxVersion
        ) {
            try {
                await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: true,
                });
                this.state.cameraGranted = true;
                this.state.microphoneGranted = true;
                this.state.browserCameraBlocked = false;
                this.state.browserMicrophoneBlocked = false;
                this.state.systemCameraBlocked = false;
                this.state.systemMicrophoneBlocked = false;
            } catch (error) {
                if (error.name === 'NotAllowedError' && !this.isStudent) {
                    alert(
                        'Your browser camera or microphone is denied. Please enable both to join the session.'
                    );
                } else {
                    alert('Camera or microphone was not found');
                }
            }
        } else {
            const cameraPermission = await navigator.permissions.query({
                name: camera,
            });
            const microphonePermission = await navigator.permissions.query({
                name: microphone,
            });
            if (cameraPermission.state === 'prompt' && microphonePermission.state === 'prompt') {
                try {
                    await navigator.mediaDevices.getUserMedia({
                        audio: true,
                        video: true,
                    });
                    this.state.cameraGranted = true;
                    this.state.microphoneGranted = true;
                    this.state.systemCameraBlocked = false;
                    this.state.systemMicrophoneBlocked = false;
                } catch (e) {
                    this.state.cameraGranted = false;
                    this.state.microphoneGranted = false;
                    this.state.browserCameraBlocked = true;
                    this.state.browserMicrophoneBlocked = true;
                }
            } else {
                await this.checkCameraAccess();
                await this.checkMicrophoneAccess();
            }
        }
        if (
            this.state.systemCameraBlocked &&
            this.state.systemMicrophoneBlocked &&
            !this.isStudent
        ) {
            alert(
                'Your system camera and microphone is denied. Please enable both to join the session.'
            );
        } else if (
            this.state.browserCameraBlocked &&
            this.state.browserMicrophoneBlocked &&
            !this.isStudent
        ) {
            alert(
                'Your browser camera and microphone is denied. Please enable both to join the session.'
            );
        } else if (this.state.browserCameraBlocked && !this.isStudent) {
            alert('Your browser camera is denied. Please enable to join the session.');
        } else if (this.state.browserMicrophoneBlocked) {
            alert('Your browser microphone is denied. Please enable to join the session.');
        } else if (
            this.state.systemCameraBlocked &&
            !this.state.systemMicrophoneBlocked &&
            !this.isStudent
        ) {
            alert('Your system camera is denied. Please enable to join the session.');
        } else if (!this.state.systemCameraBlocked && this.state.systemMicrophoneBlocked) {
            alert('Your system microphone is denied. Please enable to join the session.');
        }
    }

    // initial calling
    async finalCheckingPermission() {
        if (browser.name === 'firefox') {
            try {
                await navigator.mediaDevices.getUserMedia({
                    video: true,
                    audio: true,
                });
                console.log('Camera and microphone access granted.');
                this.state.cameraGranted = true;
                this.state.microphoneGranted = true;
                this.state.browserCameraBlocked = false;
                this.state.browserMicrophoneBlocked = false;
                this.state.systemCameraBlocked = false;
                this.state.systemMicrophoneBlocked = false;
            } catch (error) {
                this.state.cameraGranted = false;
                this.state.microphoneGranted = false;
                this.state.browserCameraBlocked = true;
                this.state.browserMicrophoneBlocked = true;
                this.state.systemCameraBlocked = true;
                this.state.systemMicrophoneBlocked = true;
                alert(
                    'Your system/browser camera or microphone is denied. Please enable to join the session.'
                );
            }
        } else {
            await this.checkPermission();
        }
    }
}

export default CheckMediaAccess;
